<template>
  <div>
    <web-header></web-header>
    <web-slide :data="data"></web-slide>

    <section class="section main-content">
      <div class="container">
        <div class="columns">

          <div class="column is-3">
          </div>
          <div class="column is-6 ">
            <div class="contact-info">

              <p>
                <i class="fa fa-phone" aria-hidden="true"></i>
                15-5149-6996
              </p>
              <p>
                <i class="fa fa-envelope" aria-hidden="true"></i>
                CONTACTO@NELSONIRANCH.COM.AR
              </p>
              <p>
                <a href="https://www.facebook.com/NelsoniRanch/?ref=br_rs" target="_blank">
                <i class="fa fa-facebook-official" aria-hidden="true"></i>
                NELSONIRANCH
                </a>
              </p>
              <p>
                <a href="https://www.instagram.com/nelsoniranch/" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
                NELSONIRANCH 
                </a>
              </p>
            </div>

            <form v-on:submit="submit($event)" method="POST">
              <div class="loading" v-if="submitting">
                <div class="spinner">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              </div>
              <div class="columns">

                <div class="column is-half">
                  <div class="field">

                    <div class="control">
                      <input class="input" required v-model="formData.firstName" type="text" placeholder="Nombre*">
                    </div>
                  </div>
                  <div class="field">

                    <div class="control">
                      <input class="input" type="text" v-model="formData.phone" placeholder="Teléfono">
                    </div>
                  </div>

                </div>
                <div class="column">
                  <div class="field">

                    <div class="control">
                      <input class="input" type="text" v-model="formData.lastName" required placeholder="Apellido*">
                    </div>
                  </div>

                  <div class="field">

                    <div class="control">
                      <input class="input" type="email" required v-model="formData.email" placeholder="E-mail*">
                    </div>
                  </div>

                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <div class="control">
                      <textarea class="textarea" required v-model="formData.message" placeholder="Escriba aquí sus comentarios*"></textarea>
                    </div>
                  </div>
                  <div class="control">
                    <p>
                      Por favor antes de enviar haga click en el siguiente casillero para comprobar que usted no es un sistema automático (Spammer)
                    </p>
                    <div class="recaptcha">
                      <div id="recaptcha" class="g-recaptcha"></div>
                      <p class="help is-danger" v-if="submitted && !formData.reCaptcha">Por favor valide que no es un robot!</p>
                    </div>
                    <p>
                      (*) campos marcados con * son obligatorios
                    </p>
                  </div>
                  <div class="control">
                    <p>
                      <button class="button is-info">Enviar</button>
                    </p>

                  </div>
                </div>

              </div>
              <div class="notification" :class="notification.type" v-if="notification.show">

                <h2 v-if="notification.type === 'is-success'">Su mensaje ha sido enviado correctamente!</h2>
                <h2 v-if="notification.type === 'is-danger'">Ups.. ha surgido un error, intente nuevamente más tarde</h2>
              </div>
            </form>

          </div>
          <div class="column is-3">
          </div>
        </div>
      </div>
      <div class="float-png"></div>
    </section>

    <web-footer></web-footer>

  </div>
</template>
<script>

import header from '@/components/header'
import slide from '@/components/slide'
import footer from '@/components/footer'
import bg from '../assets/images/contact/contacto_titulo.jpg';
export default {
  name: 'home',
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        message: '',
        reCaptcha: '',
      },
      submitting: false,
      widgetId1: null,
      submitted: false,
      notification: {
        show: false,
        type: ''
      },
      data: [{
        html: ' <h1>CONTACTO</h1>',
        style: "background:url(" + bg + ") no-repeat; background-size:cover; background-position: center; height:300px;"
      }]
    }
  },
  methods: {
    resetForm() {
      this.initReCaptcha();
      this.formData.firstName = null;
      this.formData.lastName = null;
      this.formData.email = null;
      this.formData.message = null;
      this.formData.phone = null;
      this.formData.reCaptcha = null;
      this.submitted = false;
    },
    submit(e) {
      e.preventDefault();
      this.submitted = true;
      if (this.formData.reCaptcha && this.formData.firstName && this.formData.lastName && this.formData.email && this.formData.message) {
        this.submitting = true;
        $.ajax({
          method: "POST",
          url: "http://nelsoniranch.com.ar/send.php",
          data: this.formData
        })
          .done((res) => {
            this.submitting = false;
            const resVal = JSON.parse(res);
            this.resetForm();
            this.notificationHandler(resVal);

          });
      }
    },
    notificationHandler(resVal) {
      if (!resVal.error) {
        this.notification.type = 'is-success';
      } else {
        this.notification.type = 'is-danger';
      }

      this.notification.show = true;
      setTimeout(() => {
        this.notification.show = false;
      }, 15000);
    },
    setToken: function(token) {
      this.formData.reCaptcha = token;
    },
    initReCaptcha: function() {

      setTimeout(() => {
        if (typeof grecaptcha === 'undefined') {
          this.initReCaptcha();
        }
        else {
          this.widgetId1 = grecaptcha.render('recaptcha', {
            sitekey: '6LfK_TMUAAAAAKJQzCFfN7YhA2SuPchxuCWuto_G',
            badge: 'inline',
            callback: this.setToken
          });
        }
      }, 100);

    }
  },
  components: {
    'webHeader': header,
    'webSlide': slide,
    'webFooter': footer
  },
  mounted() {
    this.initReCaptcha();
  }
}
</script>

<style lang="scss" scoped>
$green:#7cb542;
form {
  position: relative;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: white;
    opacity: 0.8;
  }
}

.spinner {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}

.spinner>div {
  width: 18px;
  height: 18px;
  background-color: $green;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0)
  }
  40% {
    -webkit-transform: scale(1.0)
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: white;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: white;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: white;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: white;
}

input,
textarea {
  background: #a8b44e
}

.input:focus,
.input.is-focused,
.input:active,
.input.is-active,
.textarea:focus,
.textarea.is-focused,
.textarea:active,
.textarea.is-active {

  border-color: #a8b44e;
  -webkit-box-shadow: 0 0 0 0.125em rgba(182, 148, 84, .25);
  box-shadow: 0 0 0 0.125em rgba(182, 148, 84, .25);
}

.recaptcha {
  margin: 1em auto;
}

.control {
  .button {
    margin-top: 2em;
  }
}

.contact-info {
  margin-left: 25%;
  display: block;
  font-family: 'Montserrat';
  margin-bottom: 5em;
  @media only screen and (max-width: 48.0625em) {
    margin-left: 0%;
   
  }
  a{
    color:black;
  }
  p {
    color: #000;
  @media only screen and (max-width: 48.0625em) {
     font-size: 0.9em;
  
   
  }
    font-size: 1em;
    margin-bottom: 20px;

    i {
      padding-right: 20px;
      font-size: 1.7em;
      color: $green;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue